import type { ReactNode } from "react";
import { Navigate } from "react-router";

import type { Role } from "../api/generated/model";
import { useSession } from "../features/auth/useSession";

/**
 * Para onde vai quem nao pode estar onde esta.
 *
 * E "/" para todo papel, e nao um caminho por papel: `RoleHome` ja escolhe o
 * painel pelo papel de quem entrou. Uma tabela de home por papel aqui seria a
 * segunda declaracao da mesma coisa, e numa mudanca futura a esquecida seria a
 * que decide. Em troca, "/" passa a ter uma obrigacao: ela precisa aceitar todo
 * papel, senao o redirecionamento cai em ciclo — e e por isso que
 * `routes.test.tsx` prende essa condicao.
 */
export const ROLE_HOME_PATH = "/";

export interface RoleGuardProps {
  /** Papeis que alcancam a rota. Vem da matriz declarada em `routes.tsx`. */
  readonly allow: readonly Role[];
  readonly children: ReactNode;
}

/**
 * Portao de PAPEL de uma rota.
 *
 * `Authenticated` responde "existe sessao?"; este responde "qual papel?". Eram
 * duas perguntas e so a primeira era feita, e por isso `/finance/pricing`,
 * `/payroll` e `/dashboards/executive` abriam com formulario editavel para uma
 * aluna que apenas digitou a URL. O backend recusava os dados, entao nao houve
 * vazamento de dado — vazou a estrutura do negocio: que a escola tem catalogo de
 * preco, politica de inadimplencia e folha por lote, e com que campos.
 *
 * **Redireciona em vez de mostrar "sem permissao".** Nao ha nada a decidir na
 * tela de uma rota que este papel nunca alcanca, e um aviso ali ainda contaria
 * que a rota existe. Quem precisa explicar a recusa e a tela que o papel PODE
 * abrir e cuja acao o servidor negou — outro caso, com outra resposta.
 */
export function RoleGuard({ allow, children }: RoleGuardProps) {
  const session = useSession();

  // Sem sessao nao ha papel a conferir. Por dentro de `Authenticated` isto nao
  // acontece — ele so renderiza os filhos com sessao plena. O retorno vazio
  // existe para que o portao continue fechado, e nao aberto, se alguem um dia o
  // montar fora daquele contexto.
  if (!session.me) return null;

  if (!allow.includes(session.me.role)) return <Navigate to={ROLE_HOME_PATH} replace />;

  return <>{children}</>;
}
